import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { INDUSTRY_REPORT_CATEGORY, INDUSTRY_REPORT_DATE, INDUSTRY_REPORT_SUBCATEGORY_FUNDING_REPORT, INDUSTRY_REPORT_SUBCATEGORY_INDUSTRY_REPORT } from 'src/app/shared/constants/common-constants';
import { SettingService } from 'src/app/shared/services/node-api/setting.service';

@Component({
  selector: 'app-micro-product-filters',
  templateUrl: './micro-product-filters.component.html',
  styleUrls: ['./micro-product-filters.component.scss']
})
export class MicroProductFiltersComponent implements OnInit {
  @Output() selectedFilter: EventEmitter<any> = new EventEmitter();

  public TYPE_OF_COMPANY = [];
  public INDUSTRY_REPORT_CATEGORY= [];
  public LOCATION = [];
  public INDUSTRY = [];
  arrayOfIndustry = [];
  public DATE_OF_COMPANY = []

  isExpandedIndustry = false;
  isExpandedLLocation = false;
  fliterOpen = false;

  public selectedDateFilter: any[] = [];
  public selectedIndustryFilter: any[] = [];
  public selectedTypeOfFilter: any[] = [];
  public allSelectedFilter = {
    category: null,
    subcategory: null,
    published_date:null
  };

  constructor(
    public settingService: SettingService,
  ) {
    this.INDUSTRY_REPORT_CATEGORY = Object.assign(INDUSTRY_REPORT_CATEGORY);
    this.DATE_OF_COMPANY = Object.assign(INDUSTRY_REPORT_DATE);
  }

  ngOnInit() {
    this.LOCATION = this.settingService.getLocationDropdown();
    this.INDUSTRY = this.settingService.getIndustryDropdown();
  }

  filterTypeFilter(value) {
    if (!value) {
      this.TYPE_OF_COMPANY = Object.assign(INDUSTRY_REPORT_SUBCATEGORY_FUNDING_REPORT);
      this.INDUSTRY_REPORT_CATEGORY = Object.assign(INDUSTRY_REPORT_CATEGORY);
    } // when nothing has typed
    this.TYPE_OF_COMPANY = Object.assign([], this.TYPE_OF_COMPANY).filter(
      (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
    this.INDUSTRY_REPORT_CATEGORY = Object.assign([], this.INDUSTRY_REPORT_CATEGORY).filter(
      (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
  }

  categoryFilterChanged(id) {
    if (this.selectedTypeOfFilter.includes(id)) {
      // this.TYPE_OF_COMPANY=[];
      this.selectedTypeOfFilter.splice(
        this.selectedTypeOfFilter.indexOf(id),
        1
      );
    } else {
      // this.TYPE_OF_COMPANY = Object.assign(id ==="IND_REPORT"? INDUSTRY_REPORT_SUBCATEGORY_FUNDING_REPORT:INDUSTRY_REPORT_SUBCATEGORY_INDUSTRY_REPORT);
      this.selectedTypeOfFilter.push(id);
    }
    this.addSubcategories(this.selectedTypeOfFilter)
    this.allSelectedFilter.category = this.selectedTypeOfFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
    // console.log(this.allSelectedFilter);
  }

  addSubcategories(codes: string[]) {
    this.TYPE_OF_COMPANY = [];
    if (codes.includes('IND_REPORT')) {
      this.TYPE_OF_COMPANY = this.TYPE_OF_COMPANY.concat(INDUSTRY_REPORT_SUBCATEGORY_INDUSTRY_REPORT);
    }
    if (codes.includes('FND_REPORT')) {
      this.TYPE_OF_COMPANY = this.TYPE_OF_COMPANY.concat(INDUSTRY_REPORT_SUBCATEGORY_FUNDING_REPORT);
    }
  }

  typeFilterChanged(id) {
    if (this.selectedIndustryFilter.includes(id)) {
      this.selectedIndustryFilter.splice(
        this.selectedIndustryFilter.indexOf(id),
        1
      );
    } else {
      this.selectedIndustryFilter.push(id);
    }
    this.allSelectedFilter.subcategory = this.selectedIndustryFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
    // console.log(this.allSelectedFilter);
  }

  dateFilterChanged(id) {
    if (this.selectedDateFilter.includes(id)) {
      this.selectedDateFilter.splice(
        this.selectedDateFilter.indexOf(id),
        1
      );
    } else {
      this.selectedDateFilter.push(id);
    }
    this.allSelectedFilter.published_date = this.selectedDateFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
    // console.log(this.allSelectedFilter);
  }

}
